import React from 'react';
import BreadcrumbNormalPage from '../../../layouts/commons/breadcrumb/NormalPage';
import PageContent from './PageContent.component';

const NormalPageComponent = () => {
  return (
    <>
      <BreadcrumbNormalPage />
      <PageContent />
    </>
  );
};

export default NormalPageComponent;
